require("moment/locale/da");

let messagesPromise;

if (process.env.NODE_ENV === "production") {
    messagesPromise = import(/* webpackChunkName: "da-generated", webpackMode: "eager" */ "@/i18n/translations/da.generated.js").then(
        generatedLanguageModule => {
            return generatedLanguageModule.default;
        }
    );
} else {
    messagesPromise = import(/* webpackChunkName: "language-development", webpackMode: "eager" */ "@/i18n/language.development").then(
        generatorModule => {
            return generatorModule.generate("da");
        }
    );
}

export default messagesPromise;
